import PortfolioConfigData from "config/portfolio-config.json";
import React from "react";
import PortfolioEvolutionChart from "./components/PortfolioEvolutionChart";
import PortfolioAnalysisTable from "./components/PortfolioAnalysisTable";
import SimpleTable from "./components/SimpleTable";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import PortfolioRischioRendimentoTableCompare from "./components/PortfolioRischioRendimentoTableCompare";
import PortfolioAnalysisTableCompare from "../../compare/components/PortfolioAnalysisTableCompare";
import { useTranslation } from "react-i18next";
import PortfolioEvolutionChartCompare from "./components/PortfolioEvolutionChartCompare";
import { useComparisonLabels } from "../../compare/ComparisonLabelsContext";

type SectionChildrenProps = { reportData: any; reportData2?: any };
const AnalisiRischioRendimentoAtteso: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
}) => {
  useTranslation();
  const labels = useComparisonLabels();
  if (!reportData) {
    return <></>;
  }
  const adaptedReportDataRischioRendimento = (dataT) => {
    const adaptedData = [];
    for (let key in dataT) {
      adaptedData.push({ label: key, weight: dataT[key] });
    }
    return adaptedData;
  };
  const adaptedData = adaptedReportDataRischioRendimento(
    reportData.analisi_rischio_rendimento_atteso.risk_return_statistics,
  );
  let adaptedData2 = null;
  if (reportData2) {
    adaptedData2 = adaptedReportDataRischioRendimento(
      reportData2.analisi_rischio_rendimento_atteso.risk_return_statistics,
    );
  }
  const configData = PortfolioConfigData.analisi_rischio_rendimento_atteso.data;

  return (
    <>
      {!reportData2 && (
        <div
          className={
            commonStyles.sectionContainerAnalisiRischioRendimentoAttesoContainer
          }
        >
          <div className={commonStyles.analisiRischioRendimentoAttesoContainer}>
            <div style={{ width: "35%" }}>
              <div className={commonStyles.subtitleChartAnalisi}>
                {configData.risk_return_statistics.label}
              </div>
              <div style={{ marginTop: 8 }}>
                <SimpleTable
                  dataObject={{
                    data: adaptedData,
                    configData: configData.risk_return_statistics,
                  }}
                />
              </div>
            </div>
            <div style={{ width: "65%" }}>
              <div className={commonStyles.subtitleChartAnalisi}>
                {configData.ibbotson_cone_table.label}
              </div>
              <div style={{ marginTop: 16 }}>
                <PortfolioAnalysisTable
                  data={
                    reportData.analisi_rischio_rendimento_atteso
                      .ibbotson_cone_table.data
                  }
                />
              </div>
            </div>
          </div>
          <div className={commonStyles.subtitleChartAnalisi}>
            {configData.ibbotson_cone_chart.label}
          </div>
          <PortfolioEvolutionChart
            data={
              reportData.analisi_rischio_rendimento_atteso.ibbotson_cone_chart
                .data
            }
          />
        </div>
      )}
      {reportData2 && (
        <div
          className={
            commonStyles.sectionContainerAnalisiRischioRendimentoAttesoContainer
          }
        >
          <div className={commonStyles.analisiRischioRendimentoAttesoContainer}>
            <div style={{ width: "40%" }}>
              <div className={commonStyles.subtitleChartAnalisi}>
                {configData.risk_return_statistics.label}
              </div>
              <div style={{ marginTop: 8 }}>
                <PortfolioRischioRendimentoTableCompare
                  dataItem={{
                    data: adaptedData,
                    configData: configData.risk_return_statistics,
                  }}
                  dataItem2={{ data: adaptedData2 }}
                />
              </div>
            </div>
            <div style={{ width: "60%" }}>
              <div className={commonStyles.subtitleChartAnalisi}>
                {configData.ibbotson_cone_table.label}
              </div>
              <div style={{ marginTop: 16 }}>
                <PortfolioAnalysisTableCompare
                  title={labels.portfolio1}
                  data={
                    reportData.analisi_rischio_rendimento_atteso
                      .ibbotson_cone_table.data
                  }
                />
              </div>
              <div style={{ marginTop: 16 }}>
                <PortfolioAnalysisTableCompare
                  title={labels.portfolio2}
                  data={
                    reportData2.analisi_rischio_rendimento_atteso
                      .ibbotson_cone_table.data
                  }
                />
              </div>
            </div>
          </div>
          <div
            className={commonStyles.subtitleChartAnalisi}
            style={{ marginTop: 16 }}
          >
            {configData.ibbotson_cone_chart.label}
          </div>
          <PortfolioEvolutionChartCompare
            data={
              reportData.analisi_rischio_rendimento_atteso.ibbotson_cone_chart
                .data
            }
            data2={
              reportData2.analisi_rischio_rendimento_atteso.ibbotson_cone_chart
                .data
            }
          />
        </div>
      )}
    </>
  );
};
export default React.memo(
  AnalisiRischioRendimentoAtteso,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    return prevProps.reportData === nextProps.reportData;
  },
);
